import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import { fetchLoggedInTeacherOption } from "../../hooks/fetchLoggedInTeacherOption";

const daysOfWeek = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

const AdmAttendanceEntry = () => {
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [timeTableData, setTimeTableData] = useState([]);
  const [organizedData, setOrganizedData] = useState([]);

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    const calendar = [];
    let week = new Array(7).fill(null);

    for (let index = 0; index < firstDay.getDay(); index += 1) {
      week[index] = null;
    }

    for (let date = 1; date <= lastDay.getDate(); date += 1) {
      const dayOfWeek = new Date(
        today.getFullYear(),
        today.getMonth(),
        date
      ).getDay();

      week[dayOfWeek] = { date, dayOfWeek };

      if (dayOfWeek === 6 || date === lastDay.getDate()) {
        calendar.push(week);
        week = new Array(7).fill(null);
      }
    }

    setOrganizedData(calendar);
  }, []);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass/`);
        const data = await response.json();

        if (data?.data) {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions(options);
        } else {
          setClassOptions([]);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
        setClassOptions([]);
      }
    };

    fetchClassData();
  }, []);

  useEffect(() => {
    const loadLoggedInTeacher = async () => {
      try {
        const loggedInTeacher = await fetchLoggedInTeacherOption();

        if (loggedInTeacher) {
          setMentors([loggedInTeacher]);
          setSelectedMentor(loggedInTeacher);
        } else {
          setMentors([]);
          setSelectedMentor(null);
        }
      } catch (error) {
        console.error("Error fetching logged-in teacher:", error);
        setMentors([]);
        setSelectedMentor(null);
      }
    };

    loadLoggedInTeacher();
  }, []);

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!selectedClass) {
        setSectionOptions([]);
        return;
      }

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}`
        );
        const data = await response.json();

        if (data?.message === "success" && Array.isArray(data.data)) {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [selectedClass]);

  useEffect(() => {
    setSelectedSection(null);
    setSelectedSubject(null);
  }, [selectedClass]);

  useEffect(() => {
    setSelectedSubject(null);
  }, [selectedSection]);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedClass) {
        setSubjectOptions([]);
        return;
      }

      try {
        const orgId = localStorage.getItem("orgId") || "";
        const branchId = localStorage.getItem("branchId") || "";
        const academicSessionId =
          localStorage.getItem("academicSessionId") || "";

        const searchParams = new URLSearchParams({
          academic_year_id: academicSessionId,
          org_id: orgId,
          branch_id: branchId,
          subject_group_id: 1,
          class_id: selectedClass.value,
        });

        const fetchSubjectOptions = async (params) => {
          const response = await fetch(
            `${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection/?${params.toString()}`
          );

          if (response.status === 204) {
            return [];
          }

          const data = await response.json();

          if (data?.message === "success" && Array.isArray(data.data)) {
            return data.data.map((subject) => ({
              value: subject.id,
              label: subject.subjectcode,
            }));
          }

          return [];
        };

        let options = [];

        if (selectedSection) {
          const sectionParams = new URLSearchParams(searchParams);
          sectionParams.set("section_id", selectedSection.value);
          options = await fetchSubjectOptions(sectionParams);
        }

        if (options.length === 0) {
          options = await fetchSubjectOptions(searchParams);
        }

        setSubjectOptions(options);
      } catch (error) {
        console.error("Error fetching subject data:", error);
        setSubjectOptions([]);
      }
    };

    fetchSubjects();
  }, [selectedClass, selectedSection]);

  useEffect(() => {
    const fetchTimeTableData = async () => {
      try {
        const orgId = localStorage.getItem("orgId") || "";
        const branchId = localStorage.getItem("branchId") || "";
        const academicYearId = localStorage.getItem("academicSessionId") || "";

        if (!selectedMentor || !orgId || !branchId || !academicYearId) {
          setTimeTableData([]);
          return;
        }

        const params = new URLSearchParams({
          academic_year_id: academicYearId,
          org_id: orgId,
          branch_id: branchId,
          teacher_id: selectedMentor.value,
          class_id: selectedClass ? selectedClass.value : "",
          section_id: selectedSection ? selectedSection.value : "",
          subject_id: selectedSubject ? selectedSubject.value : "",
        });

        const response = await fetch(
          `${ApiUrl.apiurl}TIME_TABLE/GetSearchedTimeTableList/?${params.toString()}`
        );
        const data = await response.json();

        if (data?.message === "success" && Array.isArray(data.data)) {
          setTimeTableData(data.data);
        } else {
          setTimeTableData([]);
        }
      } catch (error) {
        console.error("Error fetching timetable data:", error);
        setTimeTableData([]);
      }
    };

    fetchTimeTableData();
  }, [
    selectedMentor,
    selectedClass,
    selectedSection,
    selectedSubject,
  ]);

  const getDayIndex = (day) =>
    daysOfWeek.findIndex(
      (weekDay) => weekDay === String(day || "").toUpperCase()
    );

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                TEACHER TIME TABLE
              </p>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="teacher" className="form-label">
                          Teacher
                        </label>
                        <Select
                          inputId="teacher"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          isDisabled
                          placeholder="Logged-in teacher"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>
                        <Select
                          inputId="class"
                          options={classOptions}
                          className="detail"
                          classNamePrefix="class-dropdown"
                          placeholder="Select Class"
                          isDisabled={!selectedMentor}
                          value={selectedClass}
                          onChange={setSelectedClass}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          inputId="section"
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="section-dropdown"
                          placeholder="Select Section"
                          isDisabled={!selectedClass}
                          value={selectedSection}
                          onChange={setSelectedSection}
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="subject" className="form-label">
                          Subject
                        </label>
                        <Select
                          inputId="subject"
                          options={subjectOptions}
                          className="detail"
                          classNamePrefix="subject-dropdown"
                          placeholder="Select Subject"
                          isDisabled={!selectedClass}
                          value={selectedSubject}
                          onChange={setSelectedSubject}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        {daysOfWeek.map((day) => (
                          <th
                            key={day}
                            className="text-center bg-primary text-white"
                          >
                            {day}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {organizedData.map((week, weekIndex) => (
                        <tr key={weekIndex}>
                          {week.map((cell, cellIndex) => (
                            <td
                              key={cellIndex}
                              className="text-center"
                              style={{ minHeight: "100px" }}
                            >
                              {cell ? <strong>{cell.date}</strong> : ""}
                              <div>
                                {cell &&
                                  timeTableData
                                    .filter(
                                      (entry) =>
                                        getDayIndex(entry.schedule_day) ===
                                        cell.dayOfWeek
                                    )
                                    .map((entry, entryIndex) => (
                                      <div
                                        key={entryIndex}
                                        className="p-1 border"
                                      >
                                        <strong>Class:</strong> {entry.class}{" "}
                                        <br />
                                        <strong>Section:</strong>{" "}
                                        {entry.section} <br />
                                        <strong>Period:</strong>{" "}
                                        {entry.class_period} <br />
                                        <strong>Subject:</strong>{" "}
                                        {entry.subject} <br />
                                        <strong>Teacher:</strong>{" "}
                                        {entry.teacher_name} <br />
                                      </div>
                                    ))}
                              </div>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
